module.exports = __webpack_public_path__ + "static/img/h5-2.ec3b3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h5-2.png
// module id = O0Jf
// module chunks = 1